import React from "react";
import styled from "styled-components";
import { InputField1 } from "../../../InputField1/InputField1";

// numberInStock: "",
// numberInJeans: "",
// priceProduct: "",
// generalPriceProducts: "",

function InventoryDetail({ handleChange, form }) {
  return (
    <InventroyStyle>
      <InventoryWrapper>
        <InputField1
          type="number"
          name="numberInJeans"
          label="تعداد در جین"
          value={form.numberInJeans}
          onChange={handleChange}
          placeholder="تعداد موجود در جین را وارد کنید"
          maxLenght="50"
        />
        <InputField1
          type="text"
          name="priceProduct"
          label="قیمت تکی"
          value={form?.priceProduct?.toLocaleString()}
          onChange={handleChange}
          placeholder="قیمت فروش محصول تکی را وارد کنید"
          maxLenght="50"
        />
        <InputField1
          type="text"
          name="generalPriceProducts"
          label="قیمت کلی"
          value={form.generalPriceProducts?.toLocaleString()}
          onChange={handleChange}
          placeholder="قیمت فروش به جین در صورت مقادیر اعشاری وارد کنید"
          maxLenght="50"
        />
      </InventoryWrapper>
    </InventroyStyle>
  );
}

const InventroyStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const InventoryWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export default InventoryDetail;
